import { render, staticRenderFns } from "./Variations.vue?vue&type=template&id=b0190688&scoped=true&lang=pug&"
import script from "./Variations.vue?vue&type=script&lang=js&"
export * from "./Variations.vue?vue&type=script&lang=js&"
import style0 from "./Variations.vue?vue&type=style&index=0&id=b0190688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0190688",
  null
  
)

export default component.exports